import styled from 'styled-components';

export const DatePickerWrapper = styled.div`
  .react-datepicker .react-datepicker__month-container {
    padding: 12px;
  }
`;
